export default "__VITE_ASSET__fad9985a__"